(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["si-becoming-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const quantity = root.querySelector('[name="quantity"]');
    const currency = root.dataset.currency || 'USD';
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency});
    const update = () => {
      quantity.value = Math.max(1, Math.min(99, parseInt(quantity.value, 10) || 1));
      root.querySelectorAll('[data-total]').forEach(el => el.textContent = format.format(Number(root.dataset.price) * Number(quantity.value) / 100));
    };
    root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {quantity.value = (parseInt(quantity.value,10)||1) + Number(button.dataset.quantity);update();quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
    quantity.addEventListener('change', update);
    const track = root.querySelector('.si-gallery-track');
    const thumbs = [...root.querySelectorAll('[data-slide]')];
    thumbs.forEach(button => button.addEventListener('click', () => track.scrollTo({left:track.clientWidth * Number(button.dataset.slide),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));
    track.addEventListener('scroll', () => {const current=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((button,index)=>button.setAttribute('aria-current',String(index===current)));},{passive:true});
    const primary = root.querySelector('[data-main-atc]');
    const sticky = root.querySelector('.si-sticky');
    if ('IntersectionObserver' in window) new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top>=0;},{threshold:0}).observe(primary);
  };
  document.querySelectorAll('.si-chapter').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.si-chapter').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-bundle-story"] && !Shopify.designMode) return;
  try {
    
  function initializeSiSymbolCards(root) {
    root.querySelectorAll('.si-symbol-card').forEach((card) => {
      if (card.dataset.ready === 'true') return;
      card.dataset.ready = 'true';
      const summary = card.querySelector('summary');
      let pinned = false;
      const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      card.addEventListener('pointerenter', () => { if (canHover()) card.open = true; });
      card.addEventListener('pointerleave', () => { if (!pinned && !card.contains(document.activeElement)) card.open = false; });
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        pinned = !pinned;
        card.open = pinned;
      });
      card.addEventListener('focusin', () => { card.open = true; });
      card.addEventListener('focusout', (event) => {
        if (!pinned && !card.contains(event.relatedTarget)) card.open = false;
      });
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { pinned = false; card.open = false; }
      });
    });
  }
  initializeSiSymbolCards(document);
  document.addEventListener('shopify:section:load', (event) => initializeSiSymbolCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-chapter-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const quantity = root.querySelector('[name="quantity"]');
    const currency = root.dataset.currency || 'USD';
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency});
    const update = () => {
      quantity.value = Math.max(1, Math.min(99, parseInt(quantity.value, 10) || 1));
      root.querySelectorAll('[data-total]').forEach(el => el.textContent = format.format(Number(root.dataset.price) * Number(quantity.value) / 100));
    };
    root.querySelectorAll('[data-quantity]').forEach(button => button.addEventListener('click', () => {quantity.value = (parseInt(quantity.value,10)||1) + Number(button.dataset.quantity);update();quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
    quantity.addEventListener('change', update);
    const track = root.querySelector('.si-gallery-track');
    const thumbs = [...root.querySelectorAll('[data-slide]')];
    thumbs.forEach(button => button.addEventListener('click', () => track.scrollTo({left:track.clientWidth * Number(button.dataset.slide),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));
    track.addEventListener('scroll', () => {const current=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((button,index)=>button.setAttribute('aria-current',String(index===current)));},{passive:true});
    const primary = root.querySelector('[data-main-atc]');
    const sticky = root.querySelector('.si-sticky');
    if ('IntersectionObserver' in window) new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top>=0;},{threshold:0}).observe(primary);
  };
  document.querySelectorAll('.si-chapter').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.si-chapter').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-chapter-story"] && !Shopify.designMode) return;
  try {
    
  function initializeSiChapterSymbolCards(root) {
    root.querySelectorAll('.si-chapter-symbol-card').forEach((card) => {
      if (card.dataset.ready === 'true') return;
      card.dataset.ready = 'true';
      const summary = card.querySelector('summary');
      let pinned = false;
      const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      card.addEventListener('pointerenter', () => { if (canHover()) card.open = true; });
      card.addEventListener('pointerleave', () => { if (!pinned && !card.contains(document.activeElement)) card.open = false; });
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        pinned = !pinned;
        card.open = pinned;
      });
      card.addEventListener('focusin', () => { card.open = true; });
      card.addEventListener('focusout', (event) => {
        if (!pinned && !card.contains(event.relatedTarget)) card.open = false;
      });
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { pinned = false; card.open = false; }
      });
    });
  }
  initializeSiChapterSymbolCards(document);
  document.addEventListener('shopify:section:load', (event) => initializeSiChapterSymbolCards(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('si-deferred-video')) {
    customElements.define('si-deferred-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (!this.querySelector('video')?.hasAttribute('src')) this.observer?.observe(this);
          return;
        }
        this.initialized = true;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        const load = () => {
          if (video.hasAttribute('src')) return;
          video.src = video.dataset.src;
          video.preload = 'auto';
          video.load();
          this.observer?.disconnect();
        };
        const play = () => video.play().catch(() => { button.hidden = false; });
        button.addEventListener('click', () => {
          load();
          video.muted = false;
          play();
        });
        video.addEventListener('playing', () => { button.hidden = true; });
        video.addEventListener('error', () => { button.hidden = false; });
        const clickOnly = window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData;
        if ('IntersectionObserver' in window && !clickOnly) {
          this.observer = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            load();
          }, { rootMargin: '200px 0px', threshold: 0 });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
